module.exports = __webpack_public_path__ + "img/zanhover.5b837203.svg";